import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { LocalizableMessage, LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';
import { isLoggedIn } from 'redux/saga/selectors/user';
import { waitlistRequest } from 'redux/saga/entities/bound';
import { isEmpty } from 'helpers/verify';
import { LeadGenFormContainer } from 'features/LeadGenForm/LeadGenFormContainer';
import { messages } from './LeadGen.messages';

const noop = () => {};

export class LeadGenUnwrapped extends Component {
  constructor(props) {
    super(props);
    const { hideOnLoad } = this.props;

    this.state = {
      shouldHide: hideOnLoad,
    };
  }

  hideModule = () => this.setState({ shouldHide: true });

  render() {
    if (this.state.shouldHide) {
      return false;
    }

    const {
      backgroundColor,
      canHide,
      ctaCopy,
      singleLineBreakpoint,
      submissionType,
      subtitleCopy,
      titleCopy,
      useMarketingStyles,
      wasCaptured,
    } = this.props;

    const leadGenClasses = classNames('lead-gen', {
      'lead-gen--marketing': useMarketingStyles,
      'bg--light': backgroundColor === 'light',
      'bg--white': backgroundColor === 'white',
      'anim anim--fadeOut lead-gen--anim-delay': canHide && wasCaptured,
    });

    return (
      <div className={leadGenClasses} onAnimationEnd={canHide && wasCaptured ? this.hideModule : noop}>
        <h2 className="lead-gen__title">
          <LocalizableMessage message={titleCopy || messages.title} />
        </h2>
        <p className="lead-gen__subtitle">
          <LocalizableMessage message={subtitleCopy || messages.subtitle} />
        </p>
        <div className="lead-gen__form">
          <LeadGenFormContainer
            ctaCopy={ctaCopy}
            singleLineBreakpoint={singleLineBreakpoint}
            submissionType={submissionType}
          />
        </div>
      </div>
    );
  }
}

LeadGenUnwrapped.propTypes = {
  backgroundColor: PropTypes.oneOf(['white', 'light']),
  canHide: PropTypes.bool,
  ctaCopy: PropTypes.string,
  hideOnLoad: PropTypes.bool,
  submissionType: PropTypes.string,
  singleLineBreakpoint: PropTypes.string,
  subtitleCopy: LocalizableMessageShape,
  titleCopy: LocalizableMessageShape,
  useMarketingStyles: PropTypes.bool,
  wasCaptured: PropTypes.bool,
};

export const mapStateToProps = (state, props) => {
  const { canHide } = props;
  const wasCaptured = !isEmpty(waitlistRequest.data(state));
  return {
    hideOnLoad: isLoggedIn(state) || !!(canHide && wasCaptured),
    wasCaptured,
  };
};

export const LeadGen = connect(mapStateToProps)(LeadGenUnwrapped);
